import React from "react";
import Header from "./../Header";
import Sidebar from "./../Sidebar";
import BoardingTemplate from "./BoardingTemplate";
import Footer from "./../Footer";
const Onboarding = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <BoardingTemplate />
      <Footer />
    </>
  );
};

export default Onboarding;
